import { render, staticRenderFns } from "./BotaoSalvarAvancar.vue?vue&type=template&id=28e42acc&scoped=true"
import script from "./BotaoSalvarAvancar.vue?vue&type=script&lang=js"
export * from "./BotaoSalvarAvancar.vue?vue&type=script&lang=js"
import style0 from "./BotaoSalvarAvancar.vue?vue&type=style&index=0&id=28e42acc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e42acc",
  null
  
)

export default component.exports